{
  "pages": {
    "invoices": {
      "title": "Factures"
    },
    "payments": {
      "title": "Paiements"
    },
    "taxes": {
      "title": "Taxes"
    },
    "assets": {
      "title": "Immobilisations"
    },
    "auditTrail": {
      "title": "Piste d'audit finance"
    },
    "accounting": {
      "title": "Comptabilité"
    },
    "workflowDesigner": {
      "title": "Concepteur de workflow"
    },
    "workflows": {
      "title": "Workflows et recouvrements"
    },
    "treasury": {
      "title": "Trésorerie"
    },
    "cashForecast": {
      "title": "Prévision de trésorerie"
    },
    "setup": {
      "title": "Configuration finance"
    },
    "revenue": {
      "title": "Comptabilisation des revenus"
    },
    "reports": {
      "title": "Rapports financiers",
      "profitLoss": "Profit & Loss",
      "balanceSheet": "Balance Sheet",
      "cashFlow": "Cash Flow",
      "arAging": "AR Aging",
      "apAging": "AP Aging"
    },
    "reportBuilder": {
      "title": "Générateur de rapports"
    },
    "payables": {
      "title": "Comptes fournisseurs"
    },
    "ledger": {
      "title": "Grand livre"
    },
    "documentCapture": {
      "title": "Capture de documents (OCR)"
    },
    "integrations": {
      "title": "État des intégrations"
    },
    "expenses": {
      "title": "Dépenses"
    },
    "compliance": {
      "title": "Conformité internationale"
    },
    "collections": {
      "title": "Centre de recouvrement"
    },
    "banking": {
      "title": "Banque et rapprochement"
    },
    "budgets": {
      "title": "Budgets et écarts"
    },
    "automation": {
      "title": "Centre d'automatisation financière"
    },
    "analytics": {
      "title": "Analyses entreprise"
    },
    "setupWizard": {
      "title": "Assistant de configuration finance"
    },
    "healthCenter": {
      "title": "Centre de santé finance"
    },
    "closeCenter": {
      "title": "Clôture financière"
    },
    "businessRules": {
      "title": "Règles métier"
    },
    "dashboard": {
      "title": "Vue d'ensemble finance",
      "description": "Trésorerie, revenus et santé financière — vue exécutive selon vos droits finance",
      "noIssues": "Aucun problème ouvert — vos comptes sont en bonne santé.",
      "continueSetup": "Continuer l'assistant de configuration",
      "healthCenter": "Centre de santé",
      "setupProgress": "{{completed}}/{{total}} étapes de configuration",
      "setupIncomplete": "La configuration finance est incomplète ({{progress}}).",
      "finishSetup": "Terminer la configuration guidée",
      "setupIncompleteSuffix": "pour débloquer les contrôles de mise en production et la clôture.",
      "viewAllInHealthCenter": "Tout voir dans le centre de santé"
    },
    "chartOfAccountsJournalComposerMulti": "Chart of accounts, journal composer, multi-stage approbation, draft → approve → post",
    "amountThresholdsApprovalRoutingAndAutomation": "Amount thresholds, approbation routing, et automation triggers",
    "monthQuarterAndYearEndClose": "Month, quarter, et year-end close checklist avec task owners et dependencies",
    "automaticChecksForIssuesThatAffect": "Automatic checks pour issues that affect votre books, cash, et compliance",
    "getYourBooksReadyInNine": "Get votre books ready in nine guided steps — no accounting degree requis",
    "revenueAccounts": "Revenue accounts",
    "expenseAccounts": "Expense accounts",
    "arAging": "AR aging",
    "apAging": "AP aging",
    "revenueExpensesAndAgingAnalyticsDrill": "Revenue, expenses, et aging analytics — drill-down without accounting complexity",
    "activeAssetsDepreciationMethodAndBatch": "Active assets, depreciation method, et batch depreciation run",
    "whoChangedWhatWhenWithIp": "Who changed what, when — avec IP, device, et before/after snapshots",
    "noAuditEntriesYetChangesTo": "No audit entries yet. Changes à rules, documents, et compliance are tracked automatically.",
    "recurringJournalsRevenueRecognitionDunningAnd": "Recurring journals, revenue recognition, dunning, et depreciation — run manually ou on schedule",
    "importStatementsAutoMatchAndManually": "Import statements, auto-match, et manually reconcile bank transactions",
    "annualAndDepartmentalBudgetsWithLive": "Annual et départemental budgets avec live variance against actual GL",
    "totalOverdue": "Total overdue",
    "openReceivables": "Open receivables",
    "overdueInvoices": "Overdue factures",
    "openPromises": "Open promises",
    "openDisputes": "Open disputes",
    "overdueReceivablesDunningPromisesToPay": "Overdue receivables, dunning, promises à pay, et dispute tracking",
    "countryTaxPacksForGstVat": "Country tax packs pour GST, VAT, sales tax, et withholding",
    "financialHealth": "Financial health",
    "businessHealth": "Business health",
    "cashPosition": "Cash position",
    "revenueMtd": "Revenue (MTD)",
    "profitMtd": "Profit (MTD)",
    "pendingApprovals": "Pending approbations",
    "recommendations": "Recommendations",
    "topIssues": "Top issues",
    "expenseClaimsAndApprovalsApprovedExpenses": "Expense claims et approbations — approuvé expenses post à le general ledger",
    "pendingAccountingEvents": "Pending accounting events",
    "unreconciledBankTxns": "Unreconciled bank txns",
    "failedAutomations24h": "Failed automations (24h)",
    "accountingEventsApprovalsAndBankReconciliation": "Accounting events, approbations, et bank reconciliation status across connected modules",
    "createCustomerInvoicesPreviewAndEmail": "Create client factures, preview, et email PDF à clients",
    "trialBalanceAndAccountingEventDrill": "Trial balance et accounting event drill-down — source document → event → journal → ledger",
    "uploadVendorBillsAndReceiptsExtract": "Upload vendor bills et receipts — extract fields, review, then post",
    "openVendorPayablesAndBatchPayment": "Open vendor payables et batch paiement runs",
    "customerReceiptsArAndAccountsPayable": "Client receipts (AR) et accounts payable vendor directory",
    "saveAndRunCustomFinancialReport": "Save et run custom financial rapport definitions",
    "consolidationSummary": "Consolidation summary",
    "pLBalanceSheetCashFlow": "P&L, balance sheet, cash flow, AR aging — PDF et Excel export",
    "deferredRevenueSchedulesAndAsc606": "Deferred revenue schedules et ASC 606 straight-line recognition",
    "fiscalPeriodsBudgetsVarianceAndChart": "Fiscal periods, budgets, variance, et chart of accounts",
    "whatDoYouWantToDo": "What do you want à do?",
    "taxCodesTaxGroupsAndLive": "Tax codes, tax groups, et live tax calculation",
    "openingCash": "Opening cash",
    "expectedInflows": "Expected inflows",
    "expectedOutflows": "Expected outflows",
    "projectedClosing": "Projected closing",
    "expectedCashInAndOutBy": "Expected cash in et out by period — based on open receivables et payables due dates",
    "bankAccounts": "Bank accounts",
    "unreconciledTxns": "Unreconciled txns",
    "openPayables": "Open payables",
    "netLiquidity": "Net liquidity",
    "cashPositionLiquidityBankReconciliationStatus": "Cash position, liquidity, bank reconciliation status, et forecast",
    "configureMultiStageApprovalWorkflowsFor": "Configure multi-stage approbation flux de travails pour finance documents",
    "configurableApprovalWorkflowsAndArDunning": "Configurable approbation flux de travails et AR dunning",
    "billCustomersCollectPaymentsAndManage": "Bill clients, collect paiements, et manage collections — no accounting jargon requis",
    "configureTaxCodesAndCalculateTax": "Configure tax codes et calculate tax on transactions",
    "payVendorsManageExpensesAndRun": "Pay vendors, manage expenses, et run paiement batches — we post à le ledger pour you",
    "setupCloseHealthWorkflowsAndPlatform": "Setup, close, health, flux de travails, et platform governance"
  },
  "workspaces": {
    "receivables": "Créances",
    "tax": "Fiscalité",
    "payables": "Dettes fournisseurs",
    "administration": "Administration"
  },
  "toast": {
    "journalPosted": "Journal comptabilisé",
    "accountCreated": "Compte créé",
    "journalDraftCreated": "Brouillon de journal créé",
    "periodLocked": "Période verrouillée",
    "periodReopened": "Période rouverte",
    "dunningSent": "{{count}} relances envoyées",
    "reportExported": "{{reportType}} exporté en {{format}}",
    "consolidationClosed": "Consolidation {{runNumber}} clôturée ({{status}})",
    "taxCreated": "Taxe créée",
    "stepComplete": "{{stepName}} marquée terminée",
    "financeLive": "La finance est opérationnelle !",
    "invoiceSent": "Facture envoyée à {{email}}",
    "reportSaved": "Rapport enregistré",
    "paymentRecorded": "Paiement enregistré",
    "ruleSaved": "Règle enregistrée",
    "budgetCreated": "Budget créé",
    "workflowSaved": "Workflow enregistré",
    "paymentRunCreated": "Lot de paiement créé à partir des dettes ouvertes",
    "paymentRunPosted": "Lot de paiement comptabilisé",
    "closeRunStarted": "Clôture démarrée ({{closeType}})",
    "taskCompleted": "Tâche terminée : {{taskName}}",
    "deferredScheduleCreated": "Échéancier de revenus différés créé",
    "recognizedLines": "{{count}} lignes d'échéancier comptabilisées",
    "depreciationComplete": "Amortissement terminé ({{count}} journaux comptabilisés)",
    "importedTransactions": "{{count}} transactions importées",
    "importedOfx": "{{count}} transactions OFX importées",
    "importedMt940": "{{count}} transactions MT940 importées",
    "bankFeedConfigured": "Flux bancaire configuré",
    "autoMatched": "{{count}} transactions rapprochées automatiquement",
    "reconciliationFinalized": "Rapprochement finalisé ({{status}}) pour le {{date}}",
    "invoiceCreated": "Facture créée"
  },
  "errors": {
    "journalApprovalOnly": "Seules les écritures de journal ont un workflow d'approbation",
    "accountCodeNameRequired": "Le code et le nom du compte sont requis",
    "journalAccountsAmount": "Sélectionnez des comptes et saisissez un montant positif",
    "postFailed": "Échec de la comptabilisation",
    "createAccountFailed": "Échec de la création du compte",
    "createJournalFailed": "Échec de la création du journal",
    "loadFiscalPeriods": "Échec du chargement des périodes fiscales",
    "lockPeriodFailed": "Échec du verrouillage de la période",
    "reopenPeriodFailed": "Échec de la réouverture de la période",
    "createBudgetFailed": "Échec de la création du budget",
    "loadWorkflows": "Échec du chargement des workflows",
    "dunningRunFailed": "Échec de la relance",
    "loadProfitLoss": "Échec du chargement du compte de résultat",
    "loadBalanceSheet": "Échec du chargement du bilan",
    "loadCashFlow": "Échec du chargement des flux de trésorerie",
    "loadArAging": "Échec du chargement de l'ancienneté créances",
    "exportFailed": "Échec de l'export",
    "fiscalYearPeriodRequired": "Saisissez une année fiscale et une période valides",
    "consolidationCloseFailed": "Échec de la clôture de consolidation",
    "loadTaxes": "Échec du chargement des taxes",
    "taxCalculationFailed": "Échec du calcul fiscal",
    "taxCodeNameRequired": "Le code et le nom de la taxe sont requis",
    "createTaxFailed": "Échec de la création de la taxe",
    "loadWizard": "Échec du chargement de l'assistant",
    "saveProgressFailed": "Échec de l'enregistrement de la progression",
    "recipientEmailRequired": "Saisissez l'e-mail du destinataire",
    "loadInvoicePreview": "Échec du chargement de l'aperçu de facture",
    "sendInvoiceFailed": "Échec de l'envoi de la facture",
    "loadReports": "Échec du chargement des rapports",
    "saveReportFailed": "Échec de l'enregistrement du rapport",
    "runReportFailed": "Échec de l'exécution du rapport",
    "customerAmountRequired": "Sélectionnez un client et saisissez un montant valide",
    "recordPaymentFailed": "Échec de l'enregistrement du paiement",
    "loadRules": "Échec du chargement des règles",
    "saveRuleFailed": "Échec de l'enregistrement de la règle",
    "budgetCodeNameRequired": "Le code et le nom du budget sont requis",
    "createBudgetFailedShort": "Échec de la création du budget",
    "workflowFieldsRequired": "Le code, le nom et au moins une étape sont requis",
    "saveWorkflowFailed": "Échec de l'enregistrement du workflow",
    "loadApData": "Échec du chargement des données fournisseurs",
    "createPaymentRunFailed": "Échec de la création du lot de paiement",
    "loadCloseRuns": "Échec du chargement des clôtures",
    "loadTasks": "Échec du chargement des tâches",
    "startCloseFailed": "Échec du démarrage de la clôture",
    "completeTaskFailed": "Échec de la finalisation de la tâche",
    "loadDeferredRevenue": "Échec du chargement des revenus différés",
    "validAmountRequired": "Saisissez un montant valide",
    "createFailed": "Échec de la création",
    "recognitionRunFailed": "Échec de la comptabilisation",
    "loadAssets": "Échec du chargement des immobilisations",
    "depreciationRunFailed": "Échec de l'amortissement",
    "loadBankAccounts": "Échec du chargement des comptes bancaires",
    "loadUnmatched": "Échec du chargement des transactions non rapprochées",
    "importFailed": "Échec de l'import",
    "ofxImportFailed": "Échec de l'import OFX",
    "mt940ImportFailed": "Échec de l'import MT940",
    "saveFeedConfigFailed": "Échec de l'enregistrement du flux bancaire",
    "autoMatchFailed": "Échec du rapprochement automatique",
    "manualMatchFailed": "Échec du rapprochement manuel",
    "statementDateBalanceRequired": "Saisissez une date de relevé et un solde valides",
    "finalizeReconciliationFailed": "Échec de la finalisation du rapprochement",
    "invoiceTotalRequired": "Le total de la facture doit être supérieur à zéro",
    "lineItemRequired": "Ajoutez au moins une ligne",
    "customerEmailRequired": "Sélectionnez un client pour envoyer la facture par e-mail",
    "createInvoiceFailed": "Échec de la création de la facture",
    "pdfDownloadFailed": "Échec du téléchargement PDF",
    "printFailed": "Échec de l'impression",
    "loadAuditTrail": "Échec du chargement de la piste d'audit",
    "createExpenseFailed": "Échec de la création de la dépense",
    "loadAutomation": "Échec du chargement de l'automatisation",
    "jobRunFailed": "Échec de l'exécution du job",
    "loadCashForecast": "Échec du chargement de la prévision de trésorerie",
    "loadTreasury": "Échec du chargement de la trésorerie",
    "loadTrialBalance": "Échec du chargement de la balance",
    "loadCollections": "Échec du chargement des recouvrements",
    "loadCompliance": "Échec du chargement de la conformité",
    "activationFailed": "Échec de l'activation",
    "loadDocuments": "Échec du chargement des documents",
    "captureFailed": "Échec de la capture",
    "loadIntegrationHealth": "Échec du chargement de l'état des intégrations",
    "loadHealthCenter": "Échec du chargement du centre de santé",
    "loadAnalytics": "Échec du chargement des analyses",
    "failedToLoadAccounts": "Échec du chargement de accounts",
    "failedToLoadJournals": "Échec du chargement de journals",
    "failedToLoadPayments": "Échec du chargement de payments",
    "failedToLoadExpenses": "Échec du chargement de expenses",
    "failedToLoadInvoices": "Échec du chargement de invoices",
    "failedToLoadAccountingEvents": "Échec du chargement de accounting events"
  },
  "invoicePreview": "Aperçu de la facture",
  "labels": {
    "accountCode": "Account code",
    "accountName": "Account name",
    "description": "Description",
    "ruleCode": "Rule code",
    "ruleName": "Rule name",
    "entityType": "Entity type",
    "amountThreshold": "Amount threshold",
    "approverRole": "Approver role",
    "closeType": "Close type",
    "fiscalYear": "Fiscal year",
    "period": "Period",
    "statementDate": "Statement date",
    "statementBalance": "Statement balance",
    "feedType": "Feed type",
    "feedName": "Feed name",
    "selectBankAccount": "Select bank account",
    "budgetCode": "Budget code",
    "budgetName": "Budget name",
    "customer": "Client",
    "invoiceOptional": "Facture # (optional)",
    "invoiceDate": "Facture date",
    "dueDate": "Due date",
    "currency": "Currency",
    "discount": "Discount",
    "notesShownOnInvoice": "Notes (shown on facture)",
    "selectCustomer": "Select client",
    "autoGeneratedIfBlank": "Auto-generated if blank",
    "serviceOrProduct": "Service ou produit",
    "recipientEmail": "Recipient email",
    "emailMessageOptional": "Email message (optional)",
    "thankYouForYourBusiness": "Thank you pour votre business",
    "documentType": "Document type",
    "acmeSupplies10InvoiceInv1042": "Acme Supplies&#10;Facture INV-1042&#10;Total: 1,250.00&#10;Date: 2026-05-15",
    "amount": "Amount",
    "reportCode": "Rapport code",
    "reportName": "Rapport name",
    "baseReport": "Base rapport",
    "includeLabelsCommaSeparatedKeywords": "Include labels (comma-separated keywords)",
    "accountTypes": "Account types",
    "revenueExpenseCash": "revenue, expense, cash",
    "sourceType": "Source type",
    "totalAmount": "Total amount",
    "taxCode": "Tax code",
    "taxName": "Tax name",
    "selectTax": "Select tax",
    "workflowCode": "Flux de travail code",
    "workflowName": "Flux de travail name",
    "routing": "Routing",
    "stageName": "Stage name"
  },
  "formActions": {
    "saveAccount": "Enregistrer le compte",
    "saveDraftJournal": "Enregistrer le brouillon",
    "saveReport": "Enregistrer le rapport",
    "lock": "Verrouiller",
    "reopen": "Rouvrir"
  },
  "listActions": {
    "addTax": "Ajouter une taxe",
    "createBudget": "Créer un budget",
    "startClose": "Démarrer la clôture",
    "runDunning": "Lancer les relances",
    "runRecognition": "Lancer la comptabilisation",
    "createSchedule": "Créer un échéancier",
    "createPaymentRun": "Créer un lot de paiements"
  }
}
